<template>
  <div class="func-card">
    <div class="func-card-header">
      <h2 class="func-card-title">全服金子铜钱数据</h2>
    </div>

    <!-- 总统计卡片 -->
    <div class="total-stats-container">
      <el-card class="total-card">
        <template #header><span>全服总统计</span></template>
        <div class="total-row">
          <div class="total-item">
            <span class="label">金子总量：</span>
            <span class="value gold-color">{{ totalGold }}</span>
          </div>
          <div class="total-item">
            <span class="label">铜钱总量：</span>
            <span class="value money-color">{{ totalMoney }}</span>
          </div>
          <div class="total-item">
            <span class="label">脂肪总量：</span>
            <span class="value zhifang-color">{{ totalZhifang }}</span>
          </div>
          <div class="total-item">
            <span class="label">脂肪块总量：</span>
            <span class="value zhifangkuai-color">{{ totalZhifangkuai }}</span>
          </div>
          <div class="total-item">
            <span class="label">甲总量：</span>
            <span class="value jia-color">{{ totalJia }}</span>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 用户明细表格 -->
    <div class="table-container">
      <el-table
        v-loading="loading"
        :data="userList"
        border
        stripe
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#2d3748', color: '#fff' }"
        :cell-style="{ backgroundColor: '#1e293b', color: '#f1f5f9' }"
      >
        <el-table-column label="序号" type="index" width="80" align="center" />
        <el-table-column label="角色ID" prop="userID" align="center" min-width="120" />
        <el-table-column label="角色姓名" prop="userName" align="center" min-width="150" />
        
        <el-table-column label="金子数量" prop="gold" align="center" min-width="140">
          <template #default="scope">
            <span class="gold-text">{{ scope.row.gold }}</span>
          </template>
        </el-table-column>
        
        <el-table-column label="铜钱数量" prop="money" align="center" min-width="140">
          <template #default="scope">
            <span class="money-text">{{ scope.row.money }}</span>
          </template>
        </el-table-column>
        
        <el-table-column label="脂肪数量" prop="zhifang" align="center" min-width="140">
          <template #default="scope">
            <span class="zhifang-text">{{ scope.row.zhifang }}</span>
          </template>
        </el-table-column>
        
        <el-table-column label="脂肪块数量" prop="zhifangkuai" align="center" min-width="140">
          <template #default="scope">
            <span class="zhifangkuai-text">{{ scope.row.zhifangkuai }}</span>
          </template>
        </el-table-column>
        
        <el-table-column label="甲数量" prop="jia" align="center" min-width="140">
          <template #default="scope">
            <span class="jia-text">{{ scope.row.jia }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { LOG_API } from '@/utils/apiBase';
import { ref, watch } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus';

const props = defineProps({
  serverId: { type: String, default: '' },
  selectedDate: { type: String, default: '' },
  loading: { type: Boolean, default: false }
});

// 表格数据
const userList = ref([]);

// 总计字段（新增3个）
const totalGold = ref(0);
const totalMoney = ref(0);
const totalZhifang = ref(0);
const totalZhifangkuai = ref(0);
const totalJia = ref(0);

const getData = async () => {
  if (!props.serverId) {
    userList.value = [];
    totalGold.value = 0;
    totalMoney.value = 0;
    totalZhifang.value = 0;
    totalZhifangkuai.value = 0;
    totalJia.value = 0;
    return;
  }

  try {
    const res = await axios.get(`${LOG_API}/api/GameResource/GetAllServerGoldMoney`, {
      params: { serverId: props.serverId }
    });

    console.log("接口：GetAllServerGoldMoney ", props.serverId);
    console.log("接口返回：", res.data);

    if (res.data?.code === 200 && res.data.data) {
      const data = res.data.data;
      userList.value = data.list || [];
      
      // 赋值总计（同步新增字段）
      totalGold.value = data.totalGold || 0;
      totalMoney.value = data.totalMoney || 0;
      totalZhifang.value = data.totalZhifang || 0;
      totalZhifangkuai.value = data.totalZhifangkuai || 0;
      totalJia.value = data.totalJia || 0;
    } else {
      // 清空数据
      userList.value = [];
      totalGold.value = 0;
      totalMoney.value = 0;
      totalZhifang.value = 0;
      totalZhifangkuai.value = 0;
      totalJia.value = 0;
      ElMessage.warning('暂无数据');
    }
  } catch (err) {
    console.error('获取数据失败：', err);
    ElMessage.error('获取数据失败');
  }
};

// 监听服务器ID变化
watch(
  () => props.serverId,
  () => { getData(); },
  { immediate: true }
);
</script>

<style scoped>
.total-stats-container {
  padding: 0 16px 16px;
}
.total-card {
  background-color: #2d3748 !important;
  border: none !important;
  border-radius: 8px !important;
}
:deep(.el-card__header) {
  background: transparent !important;
  color: #cbd5e1 !important;
  border-bottom: 1px solid #374151 !important;
}
.total-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px 40px;
  padding: 12px 0;
}
.total-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.total-item .label {
  font-size: 14px;
  color: #94a3b8;
}
.total-item .value {
  font-size: 22px;
  font-weight: bold;
}

/* 自定义颜色 */
.gold-color { color: #fbbf24; }
.money-color { color: #34d399; }
.zhifang-color { color: #a78bfa; }
.zhifangkuai-color { color: #fb7185; }
.jia-color { color: #f472b6; }

.table-container {
  padding: 0 16px 16px;
}
.gold-text { color: #fbbf24; font-weight: 500; }
.money-text { color: #34d399; font-weight: 500; }
.zhifang-text { color: #a78bfa; font-weight: 500; }
.zhifangkuai-text { color: #fb7185; font-weight: 500; }
.jia-text { color: #f472b6; font-weight: 500; }
</style>